import React from 'react'

import { cn } from 'src/utils'
import { TypeTittle } from 'src/types'

import { TitleProps } from './types'
import { variantTitle } from './constants'

const Title = ({ title, variant, classes }: TitleProps): JSX.Element => {
  return (
    <h1 className={cn(variantTitle[variant || TypeTittle.DEFAULT], classes)}>
      {title}
    </h1>
  )
}

export default Title
